import Google from './Google'

export default Google
// eslint-disable-next-line import/export
export * from './Google'
